export default [
  {
    path: "/raportakimhedef",
    name: "raportakimhedef",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raportakimhedef.Baslik",
      yetki: { k: [2001602] },
    },
  },
]
